import * as React from 'react';

import { ImportEvent } from '../ImportEventsReducer';

export interface ImportingPageProps {
    startImporting: () => void;
    eventsList: Array<ImportEvent>;
}

export const ImportingPage = (props: ImportingPageProps) => {
    React.useEffect(() => {
        props.startImporting();
    }, []);

    if (props.eventsList.length === 0) {
        return null;
    }

    let importedCount = props.eventsList.filter(x => x.IsImporting > 1).length;

    return (
        <div
            className="text-center">
            <p
                style={{ fontSize: 100 + 'px' }}
                className="text-center text-info">
                <i
                    className="fas fa-spin fa-circle-notch"
                    aria-hidden="true"></i>
            </p>
            <p className="text-center">Importing event {importedCount} of {props.eventsList.length}</p>
        </div>
    );
}
